import React from "react";
import { Controller } from "react-hook-form";

const TextInput = ({
  name,
  control,
  label,
  placeholder,
  rules = {},
  onValueChange,
  className = {},
  style = {},
}) => {
  const colors = {
    text: "#333",
    border: "#ccc",
    error: "#ff4d4f",
    background: "#fff",
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { value, onChange, onBlur },
        fieldState: { error },
      }) => (
        <>
          <input
            id={`text-${name}`}
            type="text"
            value={value || ""}
            onChange={(e) => {
              onChange(e.target.value);
              onValueChange && onValueChange(e.target.value);
            }}
            onBlur={onBlur}
            placeholder={placeholder}
            className={className}
            style={style}
          />
          {label && (
            <label htmlFor={`text-${name}`} className="text-body-b2">
              {label}
            </label>
          )}
        </>
      )}
    />
  );
};

export default TextInput;
